"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var serializr_1 = require("serializr");
var Reaction = /** @class */ (function () {
    function Reaction(reaction) {
        this.reactionCode = reaction.reactionCode;
    }
    tslib_1.__decorate([
        serializr_1.serializable
    ], Reaction.prototype, "reactionCode", void 0);
    return Reaction;
}());
var UserReaction = /** @class */ (function () {
    function UserReaction(userReaction) {
        this.userId = userReaction.userId;
        this.reactionTime = userReaction.reactionTime;
        this.reaction = new Reaction(userReaction.reaction);
    }
    UserReaction.prototype.equals = function (userReaction) {
        var isSameUser = this.userId === userReaction.userId;
        var isSameReaction = this.reaction.reactionCode === userReaction.reaction.reactionCode;
        return isSameUser && isSameReaction;
    };
    tslib_1.__decorate([
        serializr_1.serializable
    ], UserReaction.prototype, "userId", void 0);
    tslib_1.__decorate([
        serializr_1.serializable(serializr_1.object(Reaction))
    ], UserReaction.prototype, "reaction", void 0);
    tslib_1.__decorate([
        serializr_1.serializable
    ], UserReaction.prototype, "reactionTime", void 0);
    return UserReaction;
}());
exports.UserReaction = UserReaction;
var UsersReactions = /** @class */ (function () {
    function UsersReactions(usersReactions) {
        this.total = usersReactions.total;
        this.reactions = usersReactions.userReactions.map(function (userReaction) { return new UserReaction(userReaction); });
    }
    UsersReactions.prototype.has = function (userReaction) {
        return !!this.reactions.find(function (reaction) { return reaction.equals(userReaction); });
    };
    UsersReactions.prototype.add = function (userReaction) {
        this.total = this.reactions.push(new UserReaction(userReaction));
        return this.total;
    };
    UsersReactions.prototype.remove = function (userReaction) {
        try {
            var reactions = this.reactions.filter(function (r) {
                return !(r.userId === userReaction.userId &&
                    r.reaction.reactionCode === userReaction.reaction.reactionCode);
            });
            this.reactions = reactions;
            this.total = this.reactions.length;
        }
        catch (e) {
            console.log('UsersReactions.remove error');
        }
        return this.total;
    };
    UsersReactions.prototype.getUserIds = function () {
        return this.reactions.map(function (r) { return r.userId; });
    };
    tslib_1.__decorate([
        serializr_1.serializable,
        mobx_1.observable
    ], UsersReactions.prototype, "total", void 0);
    tslib_1.__decorate([
        serializr_1.serializable(serializr_1.list(serializr_1.object(UserReaction))),
        mobx_1.observable.shallow
    ], UsersReactions.prototype, "reactions", void 0);
    return UsersReactions;
}());
var UsersReacted = /** @class */ (function () {
    function UsersReacted(usersReacted) {
        this.total = usersReacted.total;
        this.userIds = usersReacted.userIds;
    }
    tslib_1.__decorate([
        serializr_1.serializable,
        mobx_1.observable
    ], UsersReacted.prototype, "total", void 0);
    tslib_1.__decorate([
        serializr_1.serializable(serializr_1.list(serializr_1.primitive())), mobx_1.observable.shallow
    ], UsersReacted.prototype, "userIds", void 0);
    return UsersReacted;
}());
var Reactions = /** @class */ (function () {
    function Reactions(reactionsSummary) {
        if (reactionsSummary === void 0) { reactionsSummary = {
            total: 0,
            usersReactions: {
                total: 0,
                userReactions: [],
            },
            usersReacted: {
                total: 0,
                userIds: [],
            },
        }; }
        this.total = reactionsSummary.total || 0;
        this.usersReactions = new UsersReactions(reactionsSummary.usersReactions);
        this.usersReacted = new UsersReacted(reactionsSummary.usersReacted);
    }
    Reactions.prototype.add = function (userReaction) {
        this.usersReactions.add(userReaction);
        this.setUsersReactedFromReaction();
        return this.total;
    };
    Reactions.prototype.has = function (userReaction) {
        return this.usersReactions.has(userReaction);
    };
    Reactions.prototype.setUsersReactedFromReaction = function () {
        var userIds = tslib_1.__spread(new Set(this.usersReactions.getUserIds()));
        this.usersReacted = new UsersReacted({ total: userIds.length, userIds: userIds });
        this.setTotalReactions();
    };
    Reactions.prototype.remove = function (userReaction) {
        this.usersReactions.remove(userReaction);
        this.setUsersReactedFromReaction();
        return this.total;
    };
    Reactions.prototype.setTotalReactions = function () {
        this.total = this.usersReacted.total;
    };
    Reactions.prototype.getTotalReactions = function () {
        return this.usersReactions.total;
    };
    tslib_1.__decorate([
        serializr_1.serializable
    ], Reactions.prototype, "total", void 0);
    tslib_1.__decorate([
        serializr_1.serializable(serializr_1.object(UsersReactions)),
        mobx_1.observable
    ], Reactions.prototype, "usersReactions", void 0);
    tslib_1.__decorate([
        serializr_1.serializable(serializr_1.object(UsersReacted)), mobx_1.observable
    ], Reactions.prototype, "usersReacted", void 0);
    return Reactions;
}());
exports.Reactions = Reactions;
//# sourceMappingURL=Reactions.js.map